// DelayedFallback.js
import React, { useState, useEffect } from 'react';

function DelayedFallback({ delay = 300, fallback }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return show ? fallback : null;
}

export default DelayedFallback;
